module.exports = __webpack_public_path__ + "static/hara-kiri-a4ea3f91dec786a3fa70bd0319002361.png";